import getEnvValue from './getEnvValue';

export const ENV_VERSION = process.env.VERSION || 'Utina v1.0';

export const SERVER_URL = getEnvValue('SERVER_URL'); //|| 'http://127.0.0.1:9000';

export const SUPERSET_URL = getEnvValue('SUPERSET_URL'); //|| 'http://127.0.0.1:9000';
export const SUPERSET_USERNAME = getEnvValue('SUPERSET_USERNAME'); //admin
export const SUPERSET_PWD = getEnvValue('SUPERSET_PWD'); //admin

export const ACCESS_TOKEN = 'token';
export const CONN_HEADER =
  ' {headers: {"Authorization": "Bearer", "Content-Type": "application/json","Accept": "application/json","Access-Control-Allow-Origin":"*","Access-Control-Allow-Methods":"POST, PUT, GET, OPTIONS, DELETE",} }';

export const UPLOAD_DOC_URL =
  getEnvValue('UPLOAD_DOC_URL') ;
export const UPLOAD_IMG_URL =
  getEnvValue('CATALOG_IMG_URL') ;
export const CATALOG_IMG_URL =
  getEnvValue('CATALOG_IMG_URL');

const API_BASE_URL = SERVER_URL;

export const API_BASE_URL_CINVOICE =
  (API_BASE_URL || SERVER_URL) + '/clientinvoice-service/api';
export const API_BASE_URL_PAYBENEFICIARY =
  (API_BASE_URL || SERVER_URL) + '/thidparty-service/api';
export const API_BASE_URL_COMMON =
  (API_BASE_URL || SERVER_URL) + '/configuration-service/api';

export const API_BASE_URL_DISPLAY_FRAMEWORK =
  (API_BASE_URL || SERVER_URL) + '/display-service/api';

export const API_BASE_URL_ACCOUNTING =
  (API_BASE_URL || SERVER_URL) + '/accounting-service/api';
export const API_BASE_URL_CONTRACT =
  (API_BASE_URL || SERVER_URL) + '/proposal-service/api';
export const API_BASE_URL_DOCUMENT =
  (API_BASE_URL || SERVER_URL) + '/document-service/api';
export const API_BASE_URL_OCR = (API_BASE_URL || SERVER_URL) + ':5026/api';
export const API_BASE_URL_SINVOICE =
  (API_BASE_URL || SERVER_URL) + '/supplierinvoice-service/api';
export const API_BASE_URL_PAYMENT =
  (API_BASE_URL || SERVER_URL) + '/payment-service/api';
export const API_BASE_URL_WORKFLOW =
  (API_BASE_URL || SERVER_URL) + '/workflow-service/api';
export const API_BASE_URL_PRICING =
  (API_BASE_URL || SERVER_URL) + '/pricing-service/api';
export const API_BASE_URL_GUARANTY = (API_BASE_URL || SERVER_URL) + ':5032/api';
export const API_BASE_URL_FINENGINE =
  (API_BASE_URL || SERVER_URL) + '/finengine-service/api';
export const API_BASE_URL_PURCHASEORDER =
  (API_BASE_URL || SERVER_URL) + ':5031/api';
export const API_BASE_URL_SCORINGENGINE =
  (API_BASE_URL || SERVER_URL) + '/scoring-service/api';
export const API_BASE_URL_AUTH =
  (API_BASE_URL || SERVER_URL) + ':8088/authenticate';
export const API_BASE_URL_USER =
  (API_BASE_URL || SERVER_URL) + ':8088/authenticate';

export const DISCOVERY = SERVER_URL + ':9005';

export const API_URLS = getEnvValue('API_URLS');
